import React from 'react';
import Button from '@material-ui/core/Button';
import {
  Formik, Form,
} from 'formik';
import {
  Typography, Grid, Hidden,
} from '@material-ui/core';
import * as yup from 'yup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import StandardInput from './standardinput';
import { fetchClear } from '../services/fetch/fetch.actions';

const schema = editing => yup.object().shape({
  fnr: editing ? yup.string().matches(/^[0-9]{11}$/, 'Fødselsnummer må være 11 siffer')
    : yup.string().matches(/^[0-9]{11}$/, 'Fødselsnummer må være 11 siffer').required('Fødselsnummer er påkrevd'),
  fornavn: yup.string().required('Fornavn er påkrevd'),
  etternavn: yup.string().required('Etternavn er påkrevd'),
  epost: yup.string().email('Ugyldig epost'),
  tlfprivat: yup.string().matches(/^[0-9]{1,8}$/, 'Ugyldig telefonnummer'),
});

const UserForm = ({
  handleSubmit, initialValues: inv, history, classes, isLoading,
  dispatch, requiredField, editing, deactive, disabledFields, hideButtons,
}) => (
  <Formik
    initialValues={inv}
    validationSchema={schema(editing)}
    onSubmit={handleSubmit}
  >
    {({
      errors,
      handleBlur,
      touched,
      initialValues,
      handleChange,
    }) => {
      const combo = {
        classes, errors, touched, handleBlur, initialValues,
      };
      return (
        <Form>
          <Grid
            container
            spacing={2}
          >
            <Grid item xs={12}>
              <Typography variant="body1" color="primary">Personlige opplysninger</Typography>
            </Grid>
            <StandardInput
              name="fnr"
              label="Fødselsnummer"
              size={6}
              fullWidth
              helperText="11 siffer"
              combo={combo}
              onChange={handleChange}
              isLoading={isLoading}
              required={requiredField}
              placeholder={editing ? '***********' : ''}
              InputLabelProps={editing ? {
                shrink: true,
              } : {}}
              disabled={disabledFields.fnr}
            />
            <Hidden xsDown>
              <Grid item className={classes.gridItem} sm={3} xs={12} />
            </Hidden>
            {['Fornavn', 'Etternavn', 'Epost'].map(name => (
              <StandardInput
                label={name}
                key={name}
                size={6}
                onChange={handleChange}
                combo={combo}
                fullWidth
                required={requiredField}
                isLoading={isLoading}
                disabled={disabledFields[name.toLocaleLowerCase()]}
              />
            ))}
            <StandardInput
              name="tlfprivat"
              label="Telefon"
              size={4}
              isLoading={isLoading}
              adornment="+47"
              onChange={handleChange}
              combo={combo}
              required={requiredField}
              disabled={disabledFields.tlfprivat}
            />
            {!hideButtons && [
              <Grid item xs={12} sm={4} key={1} />,
              <Grid item xs={6} sm={4} key={2}>
                <Button
                  className={classes.button}
                  variant="outlined"
                  fullWidth
                  onClick={() => {
                    dispatch(fetchClear('ADD_USER'));
                    dispatch(fetchClear('EDIT_USER'));
                    history.push('/admin/users');
                  }}
                >
                  Avbryt
                </Button>
              </Grid>,
              <Grid item xs={6} sm={4} key={3}>
                <Button
                  className={deactive ? classes.activateButton : classes.button}
                  color="primary"
                  fullWidth
                  variant="contained"
                  type="submit"
                >
                  {deactive ? 'Lagre og aktiver' : 'Lagre'}
                </Button>
              </Grid>,
            ]}
          </Grid>
        </Form>
      );
    }}
  </Formik>
);

UserForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  history: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  requiredField: PropTypes.bool,
  editing: PropTypes.bool,
  deactive: PropTypes.bool,
  disabledFields: PropTypes.object,
  hideButtons: PropTypes.bool,
};

UserForm.defaultProps = {
  handleSubmit: () => {},
  initialValues: {},
  isLoading: false,
  requiredField: false,
  editing: false,
  deactive: false,
  disabledFields: {},
  hideButtons: false,
};

const styles = () => ({
  button: {
    marginTop: '1rem',
  },
  textfield: {
    width: '100%',
  },
  gridItem: {
    paddingLeft: '0.8rem',
  },
  activateButton: {
    marginTop: '1rem',
    '&:hover': {
      backgroundColor: '#00953b',
      color: '#fff',
    },
  },
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(withStyles(styles)(UserForm)));
